import { v4 as uuidv4 } from 'uuid';

export function ProductSummary(props = {}, childrenComponents) {
	return {
		componentName: 'ProductSummaryShelfComponent',
		componentId: uuidv4(),
		componentGroup: 'ProductSummaryShelf',
		props: Object.assign(
			{
				blockClass: 'product__summary-1',
			},
			props,
		),
		childrenComponents: childrenComponents ? childrenComponents : productSummaryDefaultChildren,
	};
}
const productSummaryDefaultChildren = [
	{
		componentName: 'ProductSummaryImage',
		componentId: uuidv4(),

		props: {
			showBadge: true,
			badgeText: 'teste',
			showCollections: true,
			maxHeight: 300,
			hoverImage: {
				criteria: 'index',
				label: '',
				labelMatchCriteria: 'exact',
				index: 1,
			},
		},
		childrenComponents: [],
	},
	{
		componentName: 'ProductSummaryName',
		componentId: uuidv4(),
		props: {
			showFieldsProps: {
				showSku: false,
				showProductReference: true,
				showBrandName: true,
			},
			tag: 'h2',
			blockClass: 'douglas',
		},
		childrenComponents: [],
	},
	{
		componentName: 'AddToCartButton',
		componentId: uuidv4(),
		props: {
			onClickBehavior: 'go-to-product-page',
			onClickEventPropagation: 'enabled',
			isOneClickBuy: true,
			text: 'Add to cart button',
			unavailableText: 'unavailable',
			customToastUrl: '/checkout/#/cart',
			blockClass: 'class',
		},
		childrenComponents: [],
	},
];
